import { RequestsInstance } from 'api';
import { AxiosRequestConfig } from 'axios';
import { ILiveEvents } from 'shared/types/liveApi';

const LiveMatchApiWrapper = (requests: RequestsInstance) => {
	return {
		liveEvents: (config?: AxiosRequestConfig) => {
			return requests.get<ILiveEvents>(`/livebetting/running/events?getGameTypeCodes=${true}`, config);
		},
		eventDetail: (id: number, config?: AxiosRequestConfig) => {
			return requests.get(`/livebetting/running/events/${id}`, config);
		},
		liveMatchEventCount: (config?: AxiosRequestConfig) => {
			return requests.get(`/livebetting/running/event-count`, config);
		},
		liveSportsEvents: (id: number, config?: AxiosRequestConfig) => {
			return requests.get(`/livebetting/running/events/sports/${id}`, config);
		},
		liveEventDetailsById: (level: number, id: number, config?: AxiosRequestConfig) => {
			return requests.get(`livebetting/running/levels/${level}/categories/${id}/events/dropdown`, config);
		},
	};
};

export default LiveMatchApiWrapper;
